define('user/invite-users',['require','exports','module','api-access','api-access','knockout','plugins/router','user/invite-user-confirmation-modal','lodash','mixpanel-helper','durandal/app'],function (require, exports, module) {
    var extadminApi = require('api-access').extadmin;
    var userApi = require('api-access').user;
    var ko = require('knockout');
    var router = require('plugins/router');
    var inviteUserConfirmationModal = require('user/invite-user-confirmation-modal');
    var _ = require('lodash');
    var mixpanelHelper = require('mixpanel-helper');
    var app = require('durandal/app');

    function inviteUsers() {
        var self = this;
        self.track = mixpanelHelper.track;
        self.users = ko.observableArray();
        self.adminResponse = ko.observableArray([]);
        self.organizerResponse = ko.observableArray([]);
        var User = function User() {
            var user = {};
            user.firstName = ko.observable();
            user.lastName = ko.observable();
            user.email = ko.observable();

            user.firstName.extend({
                required: {
                    onlyIf: function () {
                        return (user.lastName() || user.email());
                    }
                }
            });

            user.lastName.extend({
                required: {
                    onlyIf: function () {
                        return (user.firstName() || user.email());
                    }
                }
            });

            user.email.extend({
                email: true,
                required: {
                    onlyIf: function () {
                        return (user.firstName() || user.lastName());
                    }
                },
                validation: [{
                    validator: function (val) {
                        var emailCount = 0;
                        for (var count = 0; count < self.users().length; count++) {
                            var existingUsers = self.users()[count];
                            if (val && existingUsers.email()) {
                                if (existingUsers.email() === val) {
                                    emailCount = emailCount + 1;
                                }
                            }
                        }
                        return emailCount <= 1;
                    }
                }]
            });

            user.isAdmin = ko.observable(false);

            return user;
        };

        self.del = function (index) {
            var properties = {
                row: index + 1
            };
            self.track('Deleting User Row', properties);
            self.users.splice(index, 1);
        };

        self.add = function () {
            var properties = {
                row: self.users().length
            };
            self.track('Adding User Row', properties);
            self.users.push(new User());
        };

        self.cancel = function () {
            self.track('Click Remind Later on Invite Users');
            router.navigate('');
        };

        self.activate = function () {
            self.users.push(new User());
            self.users.push(new User());
            self.users.push(new User());
        };

        self.errors = ko.computed(function () {
            return ko.validation.group(self.users(), {deep: true});
        });

        self.invite = function () {
            var failureBanner = {
                id: 'invite-failure-banner',
                iconClasses: 'togo-icon togo-icon-alert',
                classes: 'alert-warning',
                message: 'An unexpected error has occurred. You can try again later in the Admin Center'
            };

            userApi.me().then(function (me) {
                extadminApi.getLicense()
                .then(function (license) {
                    var organizers = {licenseKeys: [license.results[0].key], users: []};
                    var admins = {licenseKeys: [license.results[0].key], adminRoles: ['SUPER_USER'], users: []};

                    // cache user object as user details retrieved from external
                    // admin do not contain all user information
                    var userByEmail = {};
                    for (var count = 0; count < self.users().length; count++) {
                        var user = self.users()[count];
                        if (user.firstName() && user.lastName() && user.email()) {
                            userByEmail[user.email().toLowerCase()] = user;
                            if (user.isAdmin()) {
                                delete user.isAdmin;
                                admins.users.push(user);
                            } else {
                                delete user.isAdmin;
                                organizers.users.push(user);
                            }
                        }
                    }

                    $.when(extadminApi.addAdmins(me.accountKey, admins))
                    .then(function (adminResponse) {
                        self.adminResponse = adminResponse;
                    })
                    .fail(function (data) {
                        self.track('Error Inviting Admins', JSON.parse(data.responseText));
                        app.trigger('banner:addOne', failureBanner);
                    })
                    .always(function () {
                        $.when(extadminApi.addOrganizers(me.accountKey, organizers))
                        .then(function (organizerResponse) {
                            self.organizerResponse = organizerResponse;
                        })
                        .fail(function (data) {
                            self.track('Error Inviting Organizers', JSON.parse(data.responseText));
                            app.trigger('banner:addOne', failureBanner);
                        })
                        .always(function () {
                            self.processResponse(userByEmail);
                        });
                    });
                })
                .fail(function (data) {
                    self.track('Error Retrieving License', JSON.parse(data.responseText));
                    app.trigger('banner:addOne', failureBanner);
                });

                router.navigate('');
            });

            self.processResponse = function (userByEmail) {
                var success = [];
                var failure = [];
                if (self.adminResponse instanceof Array) {
                    _.forOwn(self.adminResponse, function (admin) {
                        if (typeof admin === 'function') {
                            return;
                        }
                        admin.user = userByEmail[admin.email];
                        if (_.has(admin, 'key')) {
                            success.push(admin);
                        } else {
                            failure.push(admin);
                        }
                    });
                }

                if (self.organizerResponse instanceof Array) {
                    _.forOwn(self.organizerResponse, function (organizer) {
                        if (typeof organizer === 'function') {
                            return;
                        }
                        organizer.user = userByEmail[organizer.email];
                        if (_.has(organizer, 'key')) {
                            success.push(organizer);
                        } else {
                            failure.push(organizer);
                        }
                    });
                }

                if (success.length > 0 || failure.length > 0) {
                    var properties = {
                        success: success.length,
                        failure: failure.length
                    };

                    self.track('Invited Users', properties);
                    inviteUserConfirmationModal.show(success, failure);
                }
            };
        };
    }

    module.exports = inviteUsers;
});

